import { useCapacitor } from "@/hooks/useCapacitor";

const FloatingActionButtons = ({
    children,
    className,
    position,
}: {
    children: React.ReactNode;
    className?: string;
    position?: "right" | "left";
    align?: "top" | "bottom";
}) => {
    const { isCordova } = useCapacitor();

    let pos = "right-4";
    if (position === "left") {
        pos = "left-4";
    }

    let align = "bottom-4";
    if (align === "top") {
        align = isCordova ? "top-14" : "top-4";
    }

    return <div className={`${className} fixed flex gap-2 ${align} md:bottom-4 md:top-auto ${pos}`}>{children}</div>;
};

export default FloatingActionButtons;
